<template>
  <div class="shadow my-4 px-4 rounded-lg bg-blue-200 hover:shadow-lg">
    <div class="flex items-center py-3 px-4">
      <div class="min-w-0 flex-1 flex flex-col">
        <!--        <div class="pb-2 pl-10" v-if="isCurrentRetro">-->
        <!--          <span-->
        <!--              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-green-100 text-green-800">-->
        <!--           Current-->
        <!--          </span>-->
        <!--        </div>-->
        <div class="flex py-2 items-center rounded-md">
          <div class="flex-shrink-0 items-center h-8">
            <input id="comments" aria-describedby="comments-description" name="comments" type="checkbox"
                   class="focus:ring-yellow-500 h-8 w-8 text-yellow-600 border-gray-300 rounded" v-model="isChecked"
                   @change="handleCheck(action)"/>
          </div>
          <div class="min-w-0 flex-1 px-2">
            <EditActionCard v-if="isEdit" :action="action" @cancelEdited="handleCancelEdit"
                            @actionEdited="handleActionEdited"/>
            <div v-else class="flex flex-col cursor-text">
              <div class="bg-gray-100 text-gray-400 py-2 px-3 my-2 rounded-lg italic"
                   role="alert">
                <p class="break-words font-bold whitespace-pre-line">"{{ action.card_context }}"</p>
              </div>
              <div class="break-words py-0.5 hover:bg-blue-100 rounded-md px-3" @mouseover="isMouseOver = true; "
                   @mouseleave="isMouseOver = false;"
                   :class="isMouseOver ? ' border-dashed border-yellow-400 ' : ''">
                <p class="text-md font-semibold text-black" :class="isChecked? 'line-through': ''"
                   @mouseover="isHoverOnActionText = true"
                   @mouseleave="isHoverOnActionText = false" v-on:click="handleClick">
                  {{
                    action.action
                  }}</p>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex-shrink-0 self-center flex">
        <Menu as="div" class="relative inline-block text-left">
          <div>
            <MenuButton class="-m-2 p-2 rounded-full flex items-center text-gray-400 hover:text-gray-600">
              <span class="sr-only">Open options</span>
              <DotsVerticalIcon class="h-5 w-5" aria-hidden="true"/>
            </MenuButton>
          </div>

          <transition
              enter-active-class="transition ease-out duration-100"
              enter-from-class="transform opacity-0 scale-95"
              enter-to-class="transform opacity-100 scale-100"
              leave-active-class="transition ease-in duration-75"
              leave-from-class="transform opacity-100 scale-100"
              leave-to-class="transform opacity-0 scale-95">
            <MenuItems
                class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-40">
              <div class="py-1">
                <MenuItem v-slot="{ active }" v-on:click="openRetroBoard(action)">
                  <div
                      class="cursor-pointer"
                      :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'flex px-4 py-2 text-sm']">
                    <ExternalLinkIcon class="mr-3 h-5 w-5 text-gray-400" aria-hidden="true"/>
                    <span class="cursor-pointer">Go to Retro Board</span>
                  </div>
                </MenuItem>
              </div>
              <div class="py-1">
                <MenuItem v-slot="{ active }" v-on:click="handleDelete(action)">
                  <div
                      class="cursor-pointer"
                      :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'flex px-4 py-2 text-sm']">
                    <ArchiveIcon class="mr-3 h-5 w-5 text-gray-400" aria-hidden="true"/>
                    <span class="cursor-pointer"> Delete</span>
                  </div>
                </MenuItem>
              </div>
            </MenuItems>
          </transition>
        </Menu>
      </div>
    </div>
  </div>
</template>

<script>
import {ref} from 'vue'
import {Menu, MenuButton, MenuItem, MenuItems,} from '@headlessui/vue'
import {ArchiveIcon, DotsVerticalIcon, ExternalLinkIcon} from '@heroicons/vue/solid'
import EditActionCard from "./EditActionCard";

export default {
  components: {
    EditActionCard,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    DotsVerticalIcon,
    ArchiveIcon,
    ExternalLinkIcon
  },
  props: ['action', 'roomId', 'currentTab'],
  setup(props, {emit}) {
    const isChecked = ref(props.action.is_done === true);
    const isMouseOver = ref(false);
    const isEdit = ref(false);
    const handleCheck = (action) => {
      axios.patch(route("retrospective.action.board.mark", action.action_id), {is_done: isChecked.value ? 1 : 0}).then((response) => {
        emit('fetchActions', props.currentTab, props.roomId);
      })
    };

    const handleClick = () => {
      isEdit.value = true;
      isHoverOnActionText.value = false;
    }

    const handleCancelEdit = () => {
      isMouseOver.value = false;
      isEdit.value = false;
    };

    const handleActionEdited = () => {
      isMouseOver.value = false;
      isEdit.value = false;
      emit('fetchActions');
    };

    const handleDelete = (action) => {
      if(confirm('Are you sure?')){
        axios.delete(route("retrospective.action.board.delete", action.action_id)).then((response) => {
          emit('fetchActions');
        })
      }
    };

    const isHoverOnActionText = ref(false);

    const openRetroBoard = (action) => {
      console.log(action);
      window.open(`/boards/${action.room_key}`, '_blank').focus();
    }

    return {
      isMouseOver,
      isChecked,
      handleCheck,
      isEdit,
      handleClick,
      handleCancelEdit,
      handleActionEdited,
      handleDelete,
      isHoverOnActionText,
      openRetroBoard
    }
  },
}
</script>